const ITEMS = [
  { img: "/img/home-cleaning.jpg", title: "Home Deep Cleaning", sub: "1–4 BHK, kitchen, bathroom, sofa" },
  { img: "/img/water-tank.jpg", title: "Water Tank Cleaning", sub: "Sludge removal & disinfection" },
  { img: "/img/ac-service.jpg", title: "AC Service", sub: "Service, gas refill, installation" },
  { img: "/img/construction.jpg", title: "Construction Labour", sub: "Per labourer, per day" },
];

export const HomeServices = () => (
  <section id="home-services" data-testid="home-services-section" className="bg-[#0B1120] py-20">
    <div className="mx-auto max-w-7xl px-4 sm:px-6">
      <p className="font-mono text-xs uppercase tracking-[0.2em] text-orange-400">Book a service</p>
      <h2 className="mt-3 font-heading text-3xl font-extrabold text-white sm:text-4xl">Cleaning, AC & labour on demand</h2>
      <a href="/?join=housekeeping" data-testid="home-services-join" className="mt-4 inline-block text-sm font-semibold text-orange-400 hover:text-orange-300">Want to work with us? Join as a Housekeeping Employee →</a>
      <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {ITEMS.map((i) => (
          <a key={i.title} href="/book" data-testid={`home-service-${i.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            className="group overflow-hidden border border-white/10 bg-[#0F172A] transition-colors hover:border-orange-500/60">
            <img src={i.img} alt={i.title} loading="lazy" className="h-44 w-full object-cover transition-transform duration-500 group-hover:scale-105" />
            <div className="p-5"><p className="font-semibold text-white">{i.title}</p><p className="text-sm text-slate-400">{i.sub}</p>
              <p className="mt-3 text-sm font-semibold text-orange-400">Book now →</p></div>
          </a>
        ))}
      </div>
    </div>
  </section>
);
